/**
 * Public barrel export for the MobileRoleChip component.
 * @module features/scouting/components/MobileFilterSheet/MobileRoleChip
 */
export { default } from "./MobileRoleChipContainer";
